module.exports = __webpack_public_path__ + "static/media/early_morning_light.187b7397.jpg";